import type { BuilderState } from "./builderTypes.js";

export type PolicyTemplate = {
  id: string;
  label: string;
  description: string;
  actionType: string;
  state: BuilderState;
};

export const policyTemplates: readonly PolicyTemplate[] = [
  {
    id: "refund-above-threshold",
    label: "Refund above threshold requires approval",
    description: "Refunds above EUR 100 are held for finance review. Smaller amounts auto-allow.",
    actionType: "issue_refund",
    state: {
      mode: "conditional",
      autoAllowLowRisk: false,
      defaultDecision: "allow",
      rules: [
        {
          id: "r1",
          conditions: [{ id: "c1", field: "amount", op: "gte", value: 100 }],
          decision: "require_approval"
        }
      ]
    }
  },
  {
    id: "billing-credit-above-threshold",
    label: "Billing credit above threshold requires approval",
    description:
      "Uses action type billing.credit.issue (SDK / demos). Credits at or above EUR 200 require manager sign-off.",
    actionType: "billing.credit.issue",
    state: {
      mode: "conditional",
      autoAllowLowRisk: false,
      defaultDecision: "allow",
      rules: [
        {
          id: "r1",
          conditions: [{ id: "c1", field: "amount", op: "gte", value: 200 }],
          decision: "require_approval"
        }
      ]
    }
  },
  {
    id: "issue-credit-simple-allow",
    label: "Simple account credit (legacy action type)",
    description:
      "issue_credit — broad “account credit” action; use billing.credit.issue for billing-specific flows.",
    actionType: "issue_credit",
    state: {
      mode: "allow",
      autoAllowLowRisk: false,
      defaultDecision: "allow",
      rules: []
    }
  },
  {
    id: "account-deletion-always-approval",
    label: "Account deletion always requires approval",
    description: "Any agent-initiated account deletion must be reviewed before execution.",
    actionType: "cancel_or_delete_account",
    state: {
      mode: "require_approval",
      autoAllowLowRisk: false,
      defaultDecision: "allow",
      rules: []
    }
  },
  {
    id: "external-message-high-risk",
    label: "External message requires approval if risk class high",
    description: "Outbound messages flagged as high-risk are held for review.",
    actionType: "send_external_message",
    state: {
      mode: "conditional",
      autoAllowLowRisk: false,
      defaultDecision: "allow",
      rules: [
        {
          id: "r1",
          conditions: [{ id: "c1", field: "risk_class", op: "eq", value: "high" }],
          decision: "require_approval"
        }
      ]
    }
  },
  {
    id: "plan-or-price-change-approval",
    label: "Plan or price change requires approval",
    description: "Subscription plan or pricing changes always go through human review.",
    actionType: "change_plan_or_price",
    state: {
      mode: "require_approval",
      autoAllowLowRisk: false,
      defaultDecision: "allow",
      rules: []
    }
  },
  {
    id: "contract-commitment-high-risk",
    label: "Contract commitment: high risk needs approval",
    description: "contract.commitment.send — holds high risk_class sends for review.",
    actionType: "contract.commitment.send",
    state: {
      mode: "conditional",
      autoAllowLowRisk: false,
      defaultDecision: "require_approval",
      rules: [
        {
          id: "r1",
          conditions: [{ id: "c1", field: "risk_class", op: "eq", value: "high" }],
          decision: "require_approval"
        }
      ]
    }
  }
] as const;
